import { useCallback } from 'react';

import { useDeleteConsumerFamilyChild, useShowConsumerFamily } from '@givebacks/api/backer';
import { Button, Modal, Stack, Text, notifications } from 'ui';

import { getErrorMessage_v2 } from '../../../../../utils/errorMessage';
import {
  ModalTitleWithBackButton,
  useDirectorySettingsModalProvider,
} from '../DirectorySettingsModalProvider';

const RemoveChildModalFooter = () => {
  const { meta, openModalById } = useDirectorySettingsModalProvider({});

  const { data: child } = useShowConsumerFamily({
    familyId: meta.familyId,
    include: 'children',
    select: (data) => data.children?.find((child) => child.uuid === meta.childId),
  });
  const { mutate: deleteConsumerFamilyChild } = useDeleteConsumerFamilyChild();

  const handleRemove = useCallback(() => {
    if (!meta.familyId || !meta.childId) return;

    deleteConsumerFamilyChild(
      { familyId: meta.familyId, childId: meta.childId },
      {
        onSuccess: () => {
          notifications.show({
            message: `You've removed ${child?.first_name} ${child?.last_name} from family`,
            variant: 'success',
          });
          openModalById('members');
        },
        onError: (error) => {
          notifications.show({
            message: getErrorMessage_v2(error),
            variant: 'error',
          });
        },
      }
    );
  }, [
    meta.familyId,
    meta.childId,
    deleteConsumerFamilyChild,
    child?.first_name,
    child?.last_name,
    openModalById,
  ]);

  return (
    <Modal.AffixedFooter>
      <Button color="cerise" fullWidth onClick={handleRemove}>
        Confirm Removal
      </Button>
    </Modal.AffixedFooter>
  );
};

const RemoveChildModalContent = () => {
  const { meta } = useDirectorySettingsModalProvider({});

  const { data: child } = useShowConsumerFamily({
    familyId: meta.familyId,
    include: 'children',
    select: (data) => data.children?.find((child) => child.uuid === meta.childId),
  });

  return (
    <Stack gap="lg">
      <Text fw={600}>
        Are you sure you want to remove {child?.first_name} {child?.last_name}?
      </Text>
    </Stack>
  );
};

const RemoveChildModal = () => {
  const { opened, close } = useDirectorySettingsModalProvider({
    id: 'remove-child',
  });
  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Remove Child</ModalTitleWithBackButton>}
    >
      <RemoveChildModalContent />
      <RemoveChildModalFooter />
    </Modal>
  );
};

export { RemoveChildModal };
